import { IconName } from "@/components/ui/icon";

export const STEP_LABELS = ["Details", "Stage Setup", "Profile Import", "Complete"];

export const STEP_ICONS: Record<number, IconName> = {
  1: "IconEditBig",
  2: "IconAgent",
  3: "IconPeopleAdd",
  4: "IconCheckCircle2",
};

export const STEP_TITLES: Record<number, string> = {
  1: "Details",
  2: "Stage Setup",
  3: "Profile Import",
  4: "Setup Complete",
};

type SourcingType = "scratch" | "ats_import";

export function stepLabels(sourcingType: SourcingType): string[] {
  return sourcingType === "ats_import"
    ? ["Details", "Stage Setup", "Add Profiles", "Complete"]
    : STEP_LABELS;
}

export function stepTitles(sourcingType: SourcingType): Record<number, string> {
  return sourcingType === "ats_import"
    ? { 1: "Details", 2: "Stage Setup", 3: "Add Profiles", 4: "Setup Complete" }
    : STEP_TITLES;
}

// Must match the backend `JobCreate`/`JobUpdate` `description` max_length.
// The editor stores HTML, so this counts the full HTML length.
export const MAX_JOB_DESCRIPTION_LENGTH = 20000;
